import { apiHost } from '../../../config';
import { deleteRequest } from '../../requests';

export default async function deleteCity(id: number) {
  return deleteRequest(`${apiHost}/api/admin/cities/${id}`);
}
